import React, { useState } from 'react';
import { Grid, Typography, Breadcrumbs } from '@mui/material';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import {Waypoint} from 'react-waypoint'
import Testimonial from '../testimonial';
// import ProjectSlick from '../projects';
import FootPrint from '../../footprint';

const HvacService = () => {

    const [numberBool, setNumberBool] = useState(false);

    const slides = [
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/hvac/goa-h.png' alt='Goa Airport' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>MOPA International Airport</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Goa</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/hvac/aiim-h.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>AIIMS, Jammu</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Vijaypur Samba Distt., Jammu & Kashmir</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/hvac/central-vista-h.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>Central Vista, Common Central Secretariat</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>New Delhi</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/hvac/hq27-h.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>HQ27 Bharti Reality</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Gurugram, Haryana</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/hvac/iitbhilai-h.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>IIT, Bhilai</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Kutelabhata, Chhattisgarh</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/hvac/nalanda-h.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>Nalanda University, Rajgir </Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Rajgir, Bihar</Typography>
        </Grid>,
        <Grid item xs={12} sx={{width:'90% !important'}}>
            <img src='/assets/images/services_image/hvac/ssb-warangle-h.png' alt='aiims1' style={{marginBottom:'2em'}} />
            <Typography variant='body2' className='slider-title-text' component={'h3'} sx={{mb:'0.25em'}}>SSB Hospital,  Warangal</Typography>
            <Typography variant='body2' className='normal-text' component={'p'} sx={{mt:0, mb:'0.5em'}}>Warangal, Telengana</Typography>
        </Grid>
    ]

    // const titleStyle = {fontSize:32, fontFamily:'Playfair Display', fontWeight:500, lineHeight:2}
   
return (
    <Grid item xs={12} sx={{width:'100%'}}>
        <Grid item xs={12} sx={{display: 'flex', flexFlow: 'column', alignItems:'center'}}>
            <Grid item  className='title-div'
                // sx={{px:!isMobile ? 10 : 0, width:'100%', maxWidth:1440, display:'flex', justifyContent:'center', pt:'2em'}}
            >
                <Grid item sx={{px: !isMobile && 12.5, background:!isMobile && 'url(/assets/images/hvacbg.png) no-repeat', backgroundPosition:'bottom right'}}>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to={'/'} className='normal-text title-color' style={{textDecoration:'none'}} >Home</Link>
                        <Link to={'/services'} className='normal-text title-color' style={{textDecoration:'none'}} >Services</Link>
                        <Typography variant='body2' component={'p'} sx={{color:'#535353'}}>HVAC</Typography>
                    </Breadcrumbs>
                    <Grid item xs={12} sx={{pt:'2em', pb: !isMobile ? '8em' : '6em'}}>
                        <Typography variant='body2' component={'h5'} className='titleStyle title-color' sx={{ pb:2 }}></Typography>
                        {/*<Typography variant='body2' component={'p'} className='normal-text' sx={{mb:4, lineHeight:2}}>
                            At <a href="https://www.uniqueengineersltd.com/">Unique Engineers</a>, we stand as a beacon of expertise in the field of Air Conditioning. With two of our directors holding qualifications as HVAC specialists, our foundation is deeply rooted in knowledge and experience. Our journey has allowed us to master the intricacies of Air conditioning services across a spectrum of systems.
                            <br/><br/>
                            Our HVAC services have been implemented in diverse sectors, spanning industry segments like healthcare, hospitality, education, retail, and lifestyle. Our defining trait lies in our unwavering dedication to quality and our unwavering ability to meet project deadlines. Beyond being a service provider, we are committed to exceeding the expectations of our clients by designing innovative, energy-efficient solutions suitable to their individual needs.
                            <br/><br/>
                            What sets us apart
                        </Typography>
                        <ul>
                            <li className='normal-text' sx={{mb:2, lineHeight:2}}>Core strength in Air conditioning with our leaders being qualified HVAC specialists</li>
                            <li className='normal-text' sx={{mb:2, lineHeight:2}}>Expertise in various systems like water/air-cooled chillers, VRV systems, radiant systems, geothermal systems, and thermal storage</li>
                            <li className='normal-text' sx={{mb:2, lineHeight:2}}>Successful implementation in hospitals, hotels, airports, malls, luxury apartments, educational institutions</li>
                            <li className='normal-text' sx={{mb:2, lineHeight:2}}>Commitment to quality and on-time project completion, along with environmentally conscious practices.</li>
                        </ul>*/}

<div className='cussec newcussecn1'>
<>
<section class="mep-content">
  
<h1><b>Best HVAC Company in India Delivering MEPF Excellence</b></h1>

<p>
When systems breathe right, buildings live long. At
<a href="https://www.uniqueengineersltd.com/"><b>Unique Engineers</b></a>,
we understand this truth better than most. HVAC, MEPF, fire protection, these are not just technical layers in a building; they are its pulse. Across India’s industrial, commercial, and institutional spaces, our team delivers precision, performance and partnerships that last.
</p>

<h2><b>HVAC Company in India with a Purpose-Built Approach</b></h2>

<p>
The Indian climate is diverse. So are its industries. This means HVAC solutions cannot be one-size-fits-all. Unique Engineers is an <b>HVAC company in India</b> that builds systems specific to geography, application and lifecycle cost-efficiency.
</p>

<p>Every HVAC installation we undertake is shaped by:</p>

<ul>
  <li>Regional temperature patterns</li>
  <li>Industry-specific demands (pharma, food, automobile, IT etc.)</li>
  <li>Energy codes and compliance</li>
  <li>Future expandability and service ease</li>
</ul>

<p>
We deliver centralised and decentralised HVAC systems tailored for low maintenance and long-term viability, without overdesigning or overshooting your budget.
</p>

<h2><b>Among the Top HVAC Companies in India for Industrial and Commercial Projects</b></h2>

<p>
Not all HVAC companies understand factories, data centres, or healthcare facilities. We do. And we do not copy-paste. As one of the <b>top HVAC companies in India</b>, our experience spans:
</p>

<ul>
  <li>High-performance clean rooms</li>
  <li>Dust-sensitive assembly lines</li>
  <li>Server-heavy IT spaces</li>
  <li>Large-format retail and malls</li>
  <li>Complex hotel and hospitality projects</li>
</ul>

<p>
We go beyond ducting and compressors. We look at your operational flow, thermal comfort, humidity, noise, indoor air quality and even how your team moves across spaces. The result? Systems that work silently, reliably and efficiently behind the scenes.
</p>

<h2><b>Expert HVAC Contractor in India with End-to-End Project Ownership</b></h2>

<p>
A contractor is only as good as their last project. We treat each one like our first. As a seasoned HVAC contractor in India, Unique Engineers takes responsibility across the full lifecycle:
</p>

<ul>
  <li>Requirement analysis and load calculation</li>
  <li>2D/3D design and system simulation</li>
  <li>Vendor coordination and procurement</li>
  <li>Site execution and quality audits</li>
  <li>Testing, commissioning and AMC</li>
</ul>

<p>
Our team maintains complete control over timelines and technical quality. We are not installers, we are problem solvers. Whether it is a greenfield project or retrofit, our commitment remains the same.
</p>

<h2><b>Reliable Industrial HVAC Contractors in India for Critical Environments</b></h2>

<p>
Industrial spaces are unforgiving when HVAC fails. Downtime is money lost. As industrial HVAC contractors in India, we work with facilities that cannot afford failure, be it a pharma production line or an automotive paint booth.
</p>

<p>You need:</p>

<ul>
  <li>Temperature control within ±1°C tolerance</li>
  <li>Zero contamination airflow management</li>
  <li>Redundancy for 24x7 operations</li>
  <li>Fire-safe and corrosion-resistant installations</li>
</ul>

<p>
We deliver all of the above, supported by high-efficiency chillers, advanced AHUs, insulated ducting, and automated controls. Plus, we offer periodic servicing contracts to keep your plant running without disruptions.
</p>

<h2><b>Why Unique Engineers Ranks Among the Best HVAC Companies in India</b></h2>

<p>
We do not follow trends. We follow needs. Our clients choose us not just for what we install, but how we do it:
</p>

<ul>
  <li><b>Custom-Built Solutions</b> - No off-the-shelf templates. Every project is engineered from the ground up.</li>
  <li><b>Deep Multi-Disciplinary Expertise</b> - We also offer <a href="https://www.uniqueengineersltd.com/"><b>MEP services in India</b></a>, meaning your plumbing, fire, electrical and HVAC are all coordinated.</li>
  <li><b>In-House Design &amp; Project Teams</b> - Direct control, no third-party dependencies.</li>
  <li><b>On-Time Delivery</b> - We plan for constraints and build in buffers. Delays are not in our DNA.</li>
  <li><b>Pan-India Reach</b> - From Gujarat to Odisha, Delhi to Chennai, we go where the project demands.</li>
</ul>

<h3><b>Where HVAC Meets MEPF, Fire and More</b></h3>

<p>
HVAC rarely exists in isolation. From ducts that interfere with fire sprinkler layouts to chillers sharing panels with electrical lines, integration is key. Unique Engineers is also a trusted
<a href="https://www.uniqueengineersltd.com/services/mepf-contractor-in-india/"><b>MEPF contractor in India</b></a>, offering unified services in:
</p>

<ul>
  <li>HVAC systems</li>
  <li>Plumbing and drainage</li>
  <li>Fire protection</li>
  <li>Electrical panels and cabling</li>
  <li>Building automation</li>
</ul>

<p>
We also work with certified
<a href="https://www.uniqueengineersltd.com/services/industrial-fire-fighting-contractors-in-india/"><b>industrial fire fighting contractors in India</b></a>,
ensuring your premises meet safety codes without compromising comfort or aesthetics. If you are searching for a dependable air conditioning contractor in India who understands this intersection, look no further.
</p>

<h3><b>Our Extended Services Across Building Systems</b></h3>

<p>
With a portfolio that spans high-rises to heavy industry, we also partner with top-tier builders as:
</p>

<ul>
  <li>MEP contractor in India for integrated system planning</li>
  <li><a href="https://www.uniqueengineersltd.com/services/industrial-electrical-contractors-in-india/"><b>Industrial electrical contractors in India</b></a> for HT/LT systems, DG synchronisation and energy audits</li>
  <li>Partners in green building compliance through HVAC and energy-efficient designs</li>
</ul>

<p>We keep our scope comprehensive, but our approach precise.</p>

<h3><b>What Our Clients Value Most</b></h3>

<p>Clients across India stay with us because we bring:</p>

<ul>
  <li>Single-point responsibility across HVAC and MEPF systems</li>
  <li>Zero leakage ducting and acoustically treated equipment</li>
  <li>Clean and safe site management practices</li>
  <li>Skilled technicians backed by engineers who speak the language of consultants</li>
</ul>

<p>We are not the cheapest. We are not the loudest. But we are among the most trusted.</p>

<p><b><i>Unique Engineers - Engineered For Performance, Built For Longevity.</i></b></p>

<p>
If your facility needs systems that perform without seeking attention, reach out. We design them to disappear into the background and deliver results without noise.
</p>


  
</section>
  
</>

</div>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item sx={{backgroundColor:'#F4F8FA', mt:'-3em', position:'relative', zIndex:1, px:!isMobile ? 10 : 2.5, width:'100%', display:'flex', justifyContent:'center'}}>
                <Grid item sx={{width:'100%', px:!isMobile ? 10 : 0, pt: '5em', py: !isMobile ? '5em' : '3em' }}>
                    <Grid item sx={{}}>
                        <Typography className='titleStyle title-color' sx={{ pb:'1em', textAlign: 'center'}}>Quality solutions across sectors</Typography>
                        <Grid item sx={{width:'100%', display:'flex', pb: !isMobile && '2em' }}>
                            <Grid item xs={4} sx={{}}>
                                
                                <Typography className='titleStyle title-color' sx={{ pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="8642210061">9</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Airports <br/> ventilated</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{}}>
                                <Waypoint onEnter={() => setNumberBool(true)} />
                                <Typography className='titleStyle title-color' sx={{ pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                    { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="4612210038">4</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Stadiums <br/> made comfortable </Typography>
                            </Grid>
                            <Grid item xs={4} sx={{}}>
                                <Typography className='titleStyle title-color' sx={{ pb:0, fontFamily:'Inter !important', fontWeight:'700 !important', textAlign:'center'}}>
                                { numberBool &&  <p class="numbers">
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--1" data-fake="6642212862">6</span>
                                        </span>
                                        <span class="numbers__window">
                                            <span class="numbers__window__digit numbers__window__digit--2" data-fake="8641218062">8</span>
                                        </span>
                                    </p>
                                    }
                                </Typography>
                                <Typography className='normal-text' sx={{pb:2, textAlign:'center'}}>Hospitals <br/> air conditioned</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <FootPrint title='Our projects' imageArray={slides} content='We offer unique solutions for every project we undertake and our experts examine the details minutely. We also take pride in providing sustainable solutions that minimize our carbon footprint or impact on environment.' />
            {/* <ProjectSlick /> */}
            {/* <Grid item sx={{width:'100%', backgroundColor:'#D8F2FF', ml:!isMobile ? 10 : 2.5, pr:0, py:'5em'}}> */}
                {/* <Grid item sx={{pl: !isMobile ? 12.5: 2}}> */}
                    {/* <Typography className='titleStyle title-color' sx={{ pb:3}}>Our projects</Typography> */}
                    
                    
                {/* </Grid> */}
            {/* </Grid> */}
            <Testimonial title={'Words of satisfaction'}  />
       
        <> 
        <Grid item  className='title-div'
                // sx={{px:!isMobile ? 10 : 0, width:'100%', maxWidth:1440, display:'flex', justifyContent:'center', pt:'2em'}}
            >
        <Grid item sx={{px: !isMobile && 12.5}}>
        <Grid item xs={12} sx={{pt:'2em', pb: !isMobile ? '8em' : '6em'}}>
        <div container style={{width:'100%', justifyContent:'center', margin:'0px 0px 0px'}}>
        
        <div class="cussec">
        <h4><b>Frequently Asked Questions (FAQs)</b></h4>

        
<details open className='cusfq'>
  <summary>1. What makes Unique Engineers one of the top HVAC companies in India?</summary>
  <p>Our custom-engineered systems, in-house teams, and deep cross-industry expertise distinguish us in the HVAC landscape.</p>
</details>


<details className='cusfq'>
  <summary>2. Do you offer services beyond HVAC installations?</summary>
  <p>Yes, we also provide full MEPF services, including fire protection, electrical systems and plumbing.
</p>
</details>


<details className='cusfq'>
  <summary>3. Are your HVAC solutions suitable for industrial use?</summary>
  <p>Absolutely. We specialise as industrial HVAC contractors in India, with clients in pharma, manufacturing, IT and food sectors.</p>
</details>

<details className='cusfq'>
  <summary>4. Can you handle projects outside major metro cities?</summary>
  <p>Yes. Our teams execute projects across Tier 1, 2 and even remote locations across India.</p>
</details>

<details className='cusfq'>
  <summary>5. What post-installation support do you provide?</summary>
  <p>We offer comprehensive AMC packages, performance audits and periodic servicing by trained HVAC technicians.</p>
</details>

</div>
            </div>
            </Grid></Grid></Grid></>
            </Grid>
    </Grid>
)

}

export default HvacService;